import Types from './settings.types';

export const INITIAL_STATE = {
  autoMessages: {
    isLoading: false,
    data: null,
  },
  selectedAutoMsg: {
    data: null,
    prevData: null,
  },
  prevSelectedAutoMsg: null,
  autoMsgErrors: {},
  officeHours: {
    isLoading: false,
    data: null,
    prevData: null,
  },
  responseDelay: {
    postData: null,
    putData: null,
    isFetching: true,
    error: null,
  },
  formGenerator: {
    data: null,
    isFetching: true,
    error: null,
  },
  responsiveRobot: {
    data: null,
    isFetching: true,
    error: null,
    putData: null,
    postData: null,
  },
  widget: {
    data: {
      landing: {
        supportedLangs: ['fa', 'en'],
        lang: 'fa',
        // default and required lang is fa
        defaultLang: 'fa',
        welcomeText: { fa: 'سلام خوش آمدید 👋', en: '👋 Hi welcome' },
        intro: { fa: 'توضیحات', en: 'Description' },
        startMessangingTitle: {
          fa: 'ارسال پیام برای ما',
          en: 'Send us a message',
        },
        startMessangingDescription: {
          fa: 'ما به زودی پاسخگوی شما هستیم',
          en: 'We will reply you as soon as possible',
        },
        hasError: false,
      },
      customizations: {
        logo: '',
        uploadingLogo: null,
        uploadingLogoPath: '',
        customLogo: '1',
        primaryColor: '#841474',
        secondaryColor: '',
        logoBgColor: '',
        headerTitleColor: '',
        wallpaper: 0,
        // remove these states
        showInLanding: false,
        addFrameOnLogo: false,
        playSoundForMessages: false,
        hasError: false,
      },
      view: {
        vacation: false,
        allowedAddressesEnable: false,
        allowedAddresses: [],
        notAllowedAddresses: [],
        notAllowedAddressesEnable: false,
        hasError: false,
      },
      domains: {
        allowedDomains: [],
        hasError: false,
      },
      positions: {
        direction: 'rtl',
        defaultDirection: 'rtl',
        position: {
          rtl: 'bottom-right',
          ltr: 'bottom-right',
        }, // top-left , top-right , bottom-left , bottom-right
        offset1: {
          rtl: 15,
          ltr: 0,
        },
        offset2: {
          rtl: 15,
          ltr: 0,
        },
        showWidgetInMobile: {
          rtl: false,
          ltr: false,
        },
        hasError: false,
      },
    },
    prevData: null,
    isLoading: false,
    isSubmitting: false,
  },
  emails: {
    data: null,
    isLoading: false,
    prevData: null,
  },
  general: {
    data: null,
    isLoading: false,
    prevData: null,
  },
  aiChatBot: {
    status: null,
    connectAgent: null,
  },
};

const settingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.LOADING_WIDGET_ALL_SETTINGS:
      return {
        ...state,
        widget: {
          data: state.widget.data,
          isLoading: action.payload,
          prevData: state.widget.prevData,
        },
      };

    case Types.SET_WIDGET_SETTINGS_IS_SUBMITTING:
      return {
        ...state,
        widget: {
          data: state.widget.data,
          isLoading: state.widget.isLoading,
          prevData: state.widget.prevData,
          isSubmitting: action.payload,
        },
      };

    case Types.SET_WIDGET_ALL_SETTINGS:
      const widgetData = {
        ...state.widget.data,
        landing: {
          ...state.widget.data.landing,
          ...action.payload.landing,
        },
        customizations: {
          ...state.widget.data.customizations,
          ...action.payload.customizations,
        },
        view: {
          ...state.widget.data.view,
          ...action.payload.view,
        },
        positions: {
          ...state.widget.data.positions,
          ...action.payload.positions,
        },
      };
      return {
        ...state,
        widget: {
          data: widgetData,
          prevData: widgetData,
          isLoading: false,
        },
      };

    case Types.SET_WIDGET_LANDING:
      return {
        ...state,
        widget: {
          data: {
            ...state.widget.data,
            landing: action.payload,
          },
          isLoading: false,
          prevData: state.widget.prevData,
        },
      };
    case Types.SET_WIDGET_STYLES:
      return {
        ...state,
        widget: {
          data: {
            ...state.widget.data,
            customizations: action.payload,
          },
          isLoading: false,
          prevData: state.widget.prevData,
        },
      };
    case Types.SET_WIDGET_VIEW_SETTINGS:
      return {
        ...state,
        widget: {
          data: {
            ...state.widget.data,
            view: action.payload,
          },
          isLoading: false,
          prevData: state.widget.prevData,
        },
      };

    case Types.SET_DOMAINS:
      return {
        ...state,
        widget: {
          data: {
            ...state.widget.data,
            domains: action.payload,
          },
          isLoading: false,
          prevData: state.widget.prevData,
        },
      };

    case Types.SET_POSITION:
      return {
        ...state,
        widget: {
          data: {
            ...state.widget.data,
            positions: action.payload,
          },
          isLoading: false,
          prevData: state.widget.prevData,
        },
      };

    case Types.SET_PREV_SETTINGS:
      return {
        ...state,
        widget: {
          data: state.widget.data,
          isLoading: false,
          prevData: action.payload,
        },
      };

    case Types.SET_AUTO_MESSAGES: {
      return {
        ...state,
        autoMessages: {
          ...state.autoMessages,
          data: action.payload,
          isLoading: false,
        },
      };
    }
    case Types.SET_AUTO_MESSAGES_LOADING:
      return {
        ...state,
        autoMessages: {
          ...state.autoMessages,
          isLoading: action.payload,
        },
      };
    case Types.SET_SELECTED_AUTO_MESSAGE: {
      const { setPrevData, data } = action.payload;

      return {
        ...state,
        selectedAutoMsg: {
          ...state.selectedAutoMsg,
          data,
          prevData: setPrevData ? data : state.selectedAutoMsg.prevData,
        },
      };
    }

    case Types.RESET_SELECTED_MSG_STATE_TO_INITIAL: {
      return {
        ...state,
        selectedAutoMsg: {
          data: null,
          prevData: null,
        },
        autoMsgErrors: {},
      };
    }

    case Types.SET_SELECTED_AUTO_MESSAGE_ERROR:
      return {
        ...state,
        autoMsgErrors: { ...state.autoMsgErrors, ...action.payload },
      };

    case Types.ADD_NEW_WORK_TIME_SELECTION: {
      return {
        ...state,
        officeHours: {
          ...state.officeHours,
          data: {
            ...state.officeHours.data,
            officeHours: [
              ...state.officeHours.data.officeHours,
              action.payload,
            ],
          },
        },
      };
    }

    case Types.REMOVE_WORK_TIME_SELECTION: {
      const id = action.payload;
      const newOfficeHours = state.officeHours.data.officeHours.filter(
        (item) => item.id !== id
      );

      return {
        ...state,
        officeHours: {
          ...state.officeHours,
          data: {
            ...state.officeHours.data,
            officeHours: newOfficeHours,
          },
        },
      };
    }

    case Types.SET_OFFICE_HOURS_SETTINGS: {
      const { setPrevData, ...updatedSettings } = action.payload;

      return {
        ...state,
        officeHours: {
          ...state.officeHours,
          data: updatedSettings,
          prevData: setPrevData ? updatedSettings : state.officeHours.prevData,
        },
      };
    }

    case Types.SET_EMAIL_SETTINGS: {
      const { setPrevData, ...updatedSettings } = action.payload;

      return {
        ...state,
        emails: {
          ...state.emails,
          data: updatedSettings,
          prevData: setPrevData ? updatedSettings : state.emails.prevData,
        },
      };
    }

    case Types.SET_GENERAL_SETTINGS: {
      const { setPrevData, ...updatedSettings } = action.payload;
      return {
        ...state,
        general: {
          ...state.general,
          data: updatedSettings,
          prevData: setPrevData ? updatedSettings : state.general.prevData,
        },
      };
    }

    case Types.GET_RESPONSE_DELAY_DATA_SUCCESS:
      return {
        ...state,
        responseDelay: {
          ...state.responseDelay,
          isFetching: false,
          data: action.payload,
        },
      };
    case Types.GET_RESPONSE_DELAY_DATA_FAILURE:
      return {
        ...state,
        responseDelay: {
          ...state.responseDelay,
          isFetching: true,
          data: action.payload,
        },
      };
    case Types.POST_RESPONSE_DELAY_DATA_SUCCESS:
      return {
        ...state,
        responseDelay: {
          ...state.responseDelay,
          isFetching: false,
          postData: action.payload,
        },
      };
    case Types.POST_RESPONSE_DELAY_DATA_FAILURE:
      return {
        ...state,
        responseDelay: {
          ...state.responseDelay,
          isFetching: true,
          postData: action.payload,
        },
      };
    case Types.PUT_RESPONSE_DELAY_DATA_SUCCESS:
      return {
        ...state,
        responseDelay: {
          ...state.responseDelay,
          Fetching: false,
          putData: action.payload,
        },
      };
    case Types.PUT_RESPONSE_DELAY_DATA_FAILURE:
      return {
        ...state,
        responseDelay: {
          ...state.responseDelay,
          Fetching: true,
          putData: action.payload,
        },
      };
    case Types.DELETE_RESPONSE_DELAY_DATA_SUCCESS:
      return {
        ...state,
        responseDelay: {
          ...state.responseDelay,
          isFetching: false,
          data: action.payload,
        },
      };
    case Types.DELETE_RESPONSE_DELAY_DATA_FAILURE:
      return {
        ...state,
        responseDelay: {
          ...state.responseDelay,
          isFetching: true,
          data: action.payload,
        },
      };
    case Types.FORM_GENERATOR_POST_DATA_SUCCESS:
      return {
        ...state,
        formGenerator: {
          ...state.formGenerator,
          isFetching: false,
          data: action.payload,
        },
      };
    case Types.FORM_GENERATOR_POST_DATA_FAILURE:
      return {
        ...state,
        formGenerator: {
          ...state.formGenerator,
          isFetching: false,
          data: action.payload,
        },
      };

    case Types.RESPONSIVE_ROBOT_GET_DATA_SUCCESS:
      return {
        ...state,
        responsiveRobot: {
          ...state.responsiveRobot,
          isFetching: false,
          data: action.payload,
        },
      };
    case Types.RESPONSIVE_ROBOT_GET_DATA_FAILURE:
      return {
        ...state,
        responsiveRobot: {
          ...state.responsiveRobot,
          isFetching: true,
          data: action.payload,
        },
      };
    case Types.RESPONSIVE_ROBOT_DELETE_DATA_SUCCESS:
      return {
        ...state,
        responsiveRobot: {
          ...state.responsiveRobot,
          isFetching: false,
          data: action.payload,
        },
      };
    case Types.RESPONSIVE_ROBOT_DELETE_DATA_FAILURE:
      return {
        ...state,
        responsiveRobot: {
          ...state.responsiveRobot,
          isFetching: true,
          data: action.payload,
        },
      };
    case Types.RESPONSIVE_ROBOT_PUT_DATA_SUCCESS:
      return {
        ...state,
        responsiveRobot: {
          ...state.responsiveRobot,
          isFetching: false,
          putData: action.payload,
        },
      };
    case Types.RESPONSIVE_ROBOT_PUT_DATA_FAILURE:
      return {
        ...state,
        responsiveRobot: {
          ...state.responsiveRobot,
          isFetching: true,
          putData: action.payload,
        },
      };

    case Types.SET_AI_BOT_STATUS:
      return {
        ...state,
        aiChatBot: {
          ...state,
          status: action.payload.status,
          connectAgent: action.payload.connectAgent,
        },
      };

    default:
      return state;
  }
};

export default settingsReducer;
